import { createActions, createState, createReducer } from 'reduxsauce-crud'

const DEEP = { deep: true }

export const DomiciliationReportRedux = createActions(
  {
    getRequest: ['centerId'],
    getSuccess: ['data'],
    getFailure: ['error'],
    getAllRequest: ['page'],
    getAllSuccess: ['data'],
    getAllFailure: ['error'],
    exportRequest: ['centerId'],
    exportSuccess: null,
    exportFailure: ['error'],
    exportAllRequest: null,
    exportAllSuccess: null,
    exportAllFailure: ['error'],
  },
  {
    prefix: 'DOMICILIATION_REPORT_',
  },
)

const { Types, Creators } = DomiciliationReportRedux
export const DomiciliationReportTypes = Types
export default Creators

export const INITIAL_STATE = createState(
  {
    get: { fetching: false, results: { data: [] }, error: null },
    export: { fetching: false, error: null },
  },
)

const getRequest = state => state.merge({ get: { fetching: true, error: null } }, DEEP)
const getSuccess = (state, { data }) => state.merge({ get: { fetching: false, results: data, error: null } }, DEEP)
const getFailure = (state, { error }) => state.merge({ get: { fetching: false, error } }, DEEP)
const getAllRequest = state => state.merge({ get: { fetching: true, error: null } }, DEEP)
const getAllSuccess = (state, { data }) => state.merge({ get: { fetching: false, results: data, error: null } }, DEEP)
const getAllFailure = (state, { error }) => state.merge({ get: { fetching: false, error } }, DEEP)
const exportRequest = state => state.merge({ export: { fetching: true, error: null } }, DEEP)
const exportSuccess = state => state.merge({ export: { fetching: false, error: null } }, DEEP)
const exportFailure = (state, { error }) => state.merge({ export: { fetching: false, error } }, DEEP)
const exportAllRequest = state => state.merge({ export: { fetching: true, error: null } }, DEEP)
const exportAllSuccess = state => state.merge({ export: { fetching: false, error: null } }, DEEP)
const exportAllFailure = (state, { error }) => state.merge({ export: { fetching: false, error } }, DEEP)

export const reducer = createReducer(
  INITIAL_STATE,
  {
    [Types.getRequest]: getRequest,
    [Types.getSuccess]: getSuccess,
    [Types.getFailure]: getFailure,
    [Types.getAllRequest]: getAllRequest,
    [Types.getAllSuccess]: getAllSuccess,
    [Types.getAllFailure]: getAllFailure,
    [Types.exportRequest]: exportRequest,
    [Types.exportSuccess]: exportSuccess,
    [Types.exportFailure]: exportFailure,
    [Types.exportAllRequest]: exportAllRequest,
    [Types.exportAllSuccess]: exportAllSuccess,
    [Types.exportAllFailure]: exportAllFailure,
  },
)



// WEBPACK FOOTER //
// ./src/Data/Redux/DomiciliationReportRedux.js